import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  Heading,
  Text,
  Flex,
  Image,
  Stack,
  useToast,
  useDisclosure,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Select,
  Spinner,
  ModalFooter,
  Badge,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Divider,
  Icon,
  HStack,
  VStack,
  Grid,
  GridItem,
} from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiZoomIn, FiPackage, FiTruck, FiUser, FiCalendar } from 'react-icons/fi';
import { MdCurrencyRupee } from "react-icons/md";
import { BiArrowBack } from 'react-icons/bi';
import { MdAssignment, MdCheckCircle } from 'react-icons/md';
import CustomButton from '../../components/CustomButton';
import DisplayData from '../../components/DisplayData';
import { get_all_drivers, get_dp_vehicle_list, get_vehicle_driver_list } from '../../redux/orderSlice';
import { get_vehicle_list } from '../../redux/vehiclSlice';
import { get_driver_list } from '../../redux/driverSlice';
import { get_dp_list } from '../../redux/dplistSlice';
import { useDispatch, useSelector } from 'react-redux';
import store from '../../redux/store';

const CustomerDetailList = ({ title, value, fontWeight = "bold", fontSize = "16px" }) => (
  <Flex justify="space-between" w="full">
    <Text fontSize={fontSize} fontWeight={fontWeight}>
      {title}
    </Text>
    <Text fontSize={fontSize} fontWeight={fontWeight} color="#169e49">
      {value || "N/A"}
    </Text>
  </Flex>
);

const InfoCard = ({ icon, label, value, color = "#169e49" }) => (
  <Flex align="center" gap={3} p={3} bg="white" borderRadius="md" boxShadow="sm" border="1px solid" borderColor="gray.100">
    <Icon as={icon} boxSize={5} color={color} />
    <Box>
      <Text fontSize="xs" color="gray.500" fontWeight="medium">{label}</Text>
      <Text fontSize="md" fontWeight="bold" color="gray.700">{value || "N/A"}</Text>
    </Box>
  </Flex>
);

const DefectDetail = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [udpateAsingData, setUdpateAsingData] = useState({});
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isAssigning, setIsAssigning] = useState(false);
  const [isAssigned, setIsAssigned] = useState(false);
  const toast = useToast();
  const returnData = state?.returnData || {};
  const [details, setDetails] = useState(returnData.details || []);
  const { onOpen, onClose, isOpen } = useDisclosure();
  const {
    onOpen: onOpenAsign,
    onClose: onCloseAsign,
    isOpen: isOpenAsign,
  } = useDisclosure();
  const isRefundCompleted = state?.isRefundCompleted || false;
  const {
    dp_vehicle_list,
    vehicle_driver_list,
    vehicle_loading,
    driver_loading
  } = useSelector((state) => state.orders);
  const { dp_list } = useSelector((state) => state.dplist);
  const { driver_list } = useSelector((state) => state.drivers);
  const { vehicle_list } = useSelector((state) => state.vehicles);

  const isAlreadyAssigned = details.some(item =>
    item.assign_details && item.assign_details.length > 0
  ) || isAssigned;

  const handleModalClose = () => {
    onCloseAsign();
    setUdpateAsingData({});
  };

  const handleAssignOrder = async () => {
    if (!udpateAsingData.dplist || !udpateAsingData.vehicle || !udpateAsingData.driver) {
      toast({
        title: "Validation Error",
        description: "Please select Delivery Partner, Vehicle, and Driver",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!returnData.id || !returnData.orderid || !selectedProduct) {
      toast({
        title: "Error",
        description: "Missing order or product information",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsAssigning(true);

    try {
      const formData = new FormData();
      formData.append('action', 'assign');
      formData.append('id', returnData.id.toString());
      formData.append('userid', returnData.customerid);
      formData.append('orderid', returnData.orderid);
      formData.append('details_id[]', selectedProduct.id?.toString() || selectedProduct.productid?.toString());
      formData.append('dpid[]', udpateAsingData.dplist);
      formData.append('driver_id[]', udpateAsingData.driver);
      formData.append('vehicle_id[]', udpateAsingData.vehicle);

      const response = await fetch('https://gaswale.vensframe.com/api/admin/defective_return.php', {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (result.success || result.status === 'success' || result.message === 'success') {
        toast({
          title: "Success",
          description: "Product assigned successfully!",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        setDetails(prevDetails =>
          prevDetails.map(d =>
            d.id === selectedProduct.id
              ? {
                ...d, assign_details: [{
                  dpid: udpateAsingData.dplist,
                  driverid: udpateAsingData.driver,
                  vehicleid: udpateAsingData.vehicle,
                  datetime: new Date().toISOString(),
                }]
              }
              : d
          )
        );

        handleModalClose();
      }
      else {
        throw new Error(result.message || 'Assignment failed');
      }
    } catch (error) {
      toast({
        title: "Assignment Failed",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsAssigning(false);
    }
  };

  useEffect(() => {
    if (udpateAsingData.dplist) {
      dispatch(get_dp_vehicle_list(udpateAsingData.dplist));
      setUdpateAsingData(prev => ({
        ...prev,
        vehicle: "",
        driver: ""
      }));
    }
  }, [udpateAsingData.dplist, dispatch]);

  useEffect(() => {
    if (udpateAsingData.vehicle) {
      dispatch(get_vehicle_driver_list(udpateAsingData.vehicle));
      setUdpateAsingData(prev => ({
        ...prev,
        driver: ""
      }));
    }
  }, [udpateAsingData.vehicle, dispatch]);

  useEffect(() => {
    store.dispatch(get_vehicle_list());
    store.dispatch(get_driver_list());
    store.dispatch(get_dp_list({ page: 1, rows: 100, }));
    dispatch(get_all_drivers());
  }, [dispatch]);

  if (!state?.returnData) {
    return (
      <Box textAlign="center" py={10}>
        <Text>No defective return data found</Text>
        <CustomButton
          mt={4}
          icon={<BiArrowBack color="#fff" />}
          title="Go Back"
          onClick={() => navigate(-1)}
        />
      </Box>
    );
  }

  return (
    <Box bg="gray.50" minH="100vh" pb={8}>
      {/* Enhanced Header Card with Gradient */}
      <Card
        display="flex"
        flexDirection="row"
        alignItems="center" 
        justify="space-between"
        paddingInline={6}
        paddingBlock={4}
        mb={6}
        color="white"
        boxShadow="lg"
      >
        <Flex align="center" gap={3}>
          <Heading fontSize="2xl" fontWeight="bold" color={"black"}>Defective Return Details</Heading>
        </Flex>
        <CustomButton
          icon={<BiArrowBack color="#fff" />}
          title="Back"
          height="35px"
          b_color="#000"
          onClick={() =>
            navigate("/defective-return", {
              state: {
                fromDetails: true,
                page: state?.page || 1,
                rows: state?.rows || 5,
                initialValue: state?.initialValue || 1
              }
            })
          }
        />
      </Card>

      <Stack spacing={6} px={4}>
        {details.length > 0 ? (
          <Grid templateColumns={{ base: "1fr", lg: "repeat(2, 1fr)" }} gap={6}>
            {details.map((item, index) => {
              const isAssignedProduct = item.assign_details && item.assign_details.length > 0;
              
              return (
                <GridItem key={item.id || index}>
                  <Card
                    p={0}
                    borderRadius="xl"
                    boxShadow="xl"
                    bg="white"
                    overflow="hidden"
                    border="1px solid"
                    borderColor="gray.200"
                    transition="all 0.3s"
                    _hover={{ 
                      transform: "translateY(-4px)",
                      boxShadow: "2xl" 
                    }}
                  >
                    {/* Card Header with Status Badge */}
                    <Box
                      bgGradient={isAssignedProduct ? "linear(to-r, #38a169, #48bb78)" : "linear(to-r, #f37022, #ff8c42)"}
                      p={4}
                      color="white"
                    >
                      <Flex justify="space-between" align="center">
                        <HStack>
                          <Icon as={FiPackage} boxSize={6} />
                          <Heading fontSize="lg" fontWeight="bold">
                            Product {details.length > 1 ? `#${index + 1}` : ''}
                          </Heading>
                        </HStack>
                        <Badge
                          colorScheme={isAssignedProduct ? "green" : "orange"}
                          fontSize="sm"
                          px={3}
                          py={1}
                          borderRadius="full"
                          display="flex"
                          alignItems="center"
                          gap={1}
                        >
                          {isAssignedProduct && <Icon as={MdCheckCircle} />}
                          {isAssignedProduct ? "Assigned" : "Pending"}
                        </Badge>
                      </Flex>
                    </Box>

                    {/* Tabs Section */}
                    <Tabs colorScheme="orange" variant="enclosed" p={4}>
                      <TabList borderBottom="2px solid" borderColor="gray.200">
                        <Tab fontWeight="semibold" _selected={{ color: "#f37022", borderColor: "#f37022" }}>
                          <Icon as={FiPackage} mr={2} />
                          Product Info
                        </Tab>
                        {isAssignedProduct && (
                          <Tab fontWeight="semibold" _selected={{ color: "#f37022", borderColor: "#f37022" }}>
                            <Icon as={MdAssignment} mr={2} />
                            Assignment
                          </Tab>
                        )}
                        {item.status === "3" && (
                          <Tab fontWeight="semibold" _selected={{ color: "#f37022", borderColor: "#f37022" }}>
                            <Icon as={MdCurrencyRupee} mr={2} />
                            Defective
                          </Tab>
                        )}
                      </TabList>

                      <TabPanels>
                        {/* Product Info Tab */}
                        <TabPanel p={4}>
                          <VStack spacing={4} align="stretch">
                            {/* Product Name Highlight */}
                            <Box p={4} bg="orange.50" borderRadius="lg" borderLeft="4px solid" borderColor="orange.400">
                              <Text fontSize="xs" color="gray.600" mb={1}>Product Name</Text>
                              <Text fontSize="lg" fontWeight="bold" color="orange.600">
                                {item.product_name || "N/A"}
                              </Text>
                            </Box>

                            {/* Quick Info Grid */}
                            <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                              <InfoCard icon={FiPackage} label="Product ID" value={item.productid} color="#f37022" />
                              <InfoCard icon={FiPackage} label="Quantity" value={item.qty || "0"} color="#169e49" />
                              <InfoCard icon={FiCalendar} label="Schedule Date" value={item.scheduledate === "0000-00-00" ? "NA" : item.scheduledate} color="#3182ce" />
                              <InfoCard icon={FiCalendar} label="Schedule Time" value={item.scheduletime === "0" ? "NA" : item.scheduletime} color="#3182ce" />
                            </Grid>

                            <Divider />

                            {/* Detailed Info */}
                            <Box p={4} bg="gray.50" borderRadius="lg">
                              <DisplayData title="Cylinder Type" value={item.clindertype} />
                              <DisplayData title="Description" value={item.description || "N/A"} />
                            </Box>

                            {/* Pricing Info */}
                            {/* <Box p={4} bg="green.50" borderRadius="lg" borderLeft="4px solid" borderColor="green.400">
                              <Text fontSize="sm" fontWeight="bold" color="green.700" mb={2}>Pricing Details</Text>
                              <DisplayData title="Amount" value={`₹${item.amount || "N/A"}`} />
                              <DisplayData title="GST" value={`₹${item.gst_amount || "N/A"}`} />
                              <Divider my={2} />
                              <DisplayData title="Total Amount" value={`₹${item.total_amount || "N/A"}`} />
                            </Box> */}

                            {/* Product Image Preview */}
                            <Box p={4} bg="white" borderRadius="lg" border="2px dashed" borderColor="gray.300">
                              <Flex justify="space-between" align="center">
                                <HStack>
                                  <Icon as={FiZoomIn} color="blue.500" />
                                  <Text fontWeight="semibold" color="gray.700">Product Image</Text>
                                </HStack>
                                <Button
                                  size="sm"
                                  colorScheme="blue"
                                  variant="solid"
                                  leftIcon={<FiZoomIn />}
                                  onClick={onOpen}
                                >
                                  View Full Size
                                </Button>
                              </Flex>
                            </Box>
                          </VStack>
                        </TabPanel>

                        {/* Assignment Tab */}
                        {isAssignedProduct && (
                          <TabPanel p={4}>
                            <VStack spacing={4} align="stretch">
                              {item.assign_details.map((assign, idx) => (
                                <Box key={idx} p={4} bg="green.50" borderRadius="lg" borderLeft="4px solid" borderColor="green.400">
                                  <HStack mb={3}>
                                    <Icon as={MdAssignment} color="green.600" boxSize={5} />
                                    <Text fontWeight="bold" color="green.700">Assignment Details</Text>
                                  </HStack>
                                  
                                  <Grid templateColumns="repeat(2, 1fr)" gap={3} mb={3}>
                                    <InfoCard 
                                      icon={FiTruck} 
                                      label="Delivery Partner" 
                                      value={dp_list.find(dp => dp.id === assign.dpid)?.name || assign.dpid}
                                      color="#38a169"
                                    />
                                    <InfoCard 
                                      icon={FiUser} 
                                      label="Driver" 
                                      value={driver_list.find(d => d.id === assign.driverid)?.name || assign.driverid}
                                      color="#38a169"
                                    />
                                  </Grid>

                                  <Box p={3} bg="white" borderRadius="md">
                                    <DisplayData 
                                      title="Vehicle" 
                                      value={vehicle_list.find(v => v.id === assign.vehicleid)?.vehicleno || assign.vehicleid}
                                    />
                                    <DisplayData title="Assigned Date" value={assign.datetime || "N/A"} />
                                    <DisplayData title="Returned Date" value={assign.return_date || "N/A"} />
                                  </Box>
                                </Box>
                              ))}
                            </VStack>
                          </TabPanel>
                        )}

                        {/* Defective Details Tab */}
                        {item.status === "3" && (
                          <TabPanel p={4}>
                            <VStack spacing={4} align="stretch">
                              <Box p={4} bg="red.50" borderRadius="lg" borderLeft="4px solid" borderColor="red.400">
                                <HStack mb={3}>
                                  <Icon as={MdCurrencyRupee} color="red.600" boxSize={5} />
                                  <Text fontWeight="bold" color="red.700">Defective Product Details</Text>
                                </HStack>
                                
                                <Grid templateColumns="repeat(2, 1fr)" gap={3} mb={3}>
                                  <InfoCard icon={MdCurrencyRupee} label="Unit Rate" value={`₹${item.unit_rate || "N/A"}`} color="#e53e3e" />
                                  <InfoCard icon={MdCurrencyRupee} label="GST" value={`${item.gst || item.gst_amount || "N/A"}%`} color="#e53e3e" />
                                  <InfoCard icon={FiPackage} label="Returned Qty" value={item.qty || "0"} color="#e53e3e" />
                                  <InfoCard icon={MdCurrencyRupee} label="Total Amount" value={`₹${item.total_amount || "N/A"}`} color="#e53e3e" />
                                  <InfoCard icon={MdCurrencyRupee} label="Gross Weight" value={`₹${item.cyl_gross_weight || "N/A"}`} color="#e53e3e" />
                                  <InfoCard icon={MdCurrencyRupee} label="Tare Weight" value={`₹${item.cyl_tare_weight || "N/A"}`} color="#e53e3e" />
                                  <InfoCard icon={MdCurrencyRupee} label="Net Weight" value={`₹${item.cyl_tare_weight || "N/A"}`} color="#e53e3e" />
                                </Grid>

                                <Box p={3} bg="white" borderRadius="md">
                                  <DisplayData 
                                    title="Vehicle No" 
                                    value={vehicle_list.find(v => v.id === item.vehicle_id)?.vehicleno || item.vehicle_id || "N/A"}
                                  />      
                                  <DisplayData title="Capacity" value={item.capacity || "N/A"} />
                                </Box>
                              </Box>
                            </VStack>
                          </TabPanel>
                        )}
                      </TabPanels>
                    </Tabs>

                    {/* Action Button */}
                    <Box p={4} bg="gray.50" borderTop="1px solid" borderColor="gray.200">
                      <Button
                        w="full"
                        size="lg"
                        colorScheme={isAssignedProduct ? "green" : "orange"}
                        leftIcon={isAssignedProduct ? <MdCheckCircle /> : <MdAssignment />}
                        onClick={() => {
                          setSelectedProduct(item);
                          onOpenAsign();
                        }}
                        isDisabled={isAssignedProduct}
                        _hover={!isAssignedProduct ? { transform: "scale(1.02)" } : {}}
                        transition="all 0.2s"
                      >
                        {isAssignedProduct ? "Already Assigned" : "Assign Order"}
                      </Button>
                    </Box>
                  </Card>
                </GridItem>
              );
            })}
          </Grid>
        ) : (
          <Card p={10} textAlign="center" bg="white" borderRadius="xl" boxShadow="lg">
            <Icon as={FiPackage} boxSize={16} color="gray.300" mx="auto" mb={4} />
            <Text color="gray.500" fontSize="lg">
              No product details available for this return
            </Text>
          </Card>
        )}
      </Stack>

      {/* Image View Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
        <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(10px)" />
        <ModalContent maxW="90vw" maxH="90vh" borderRadius="xl" overflow="hidden">
          <ModalHeader bg="gray.50" borderBottom="1px solid" borderColor="gray.200">
            <HStack>
              <Icon as={FiZoomIn} color="blue.500" />
              <Text>Product Image</Text>
            </HStack>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody p={0}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minH="400px"
              bg="gray.50"
            >
              <Image
                src={details.find(detail => detail.image)?.image}
                alt="Product image"
                maxW="100%"
                maxH="70vh"
                objectFit="contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <Box
                display="none"
                justifyContent="center"
                alignItems="center"
                color="gray.500"
                textAlign="center"
                p={8}
              >
                <Text>Image could not be loaded</Text>
              </Box>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Enhanced Assignment Modal */}
      <Modal
        isOpen={isOpenAsign}
        onClose={handleModalClose}
        isCentered
        closeOnOverlayClick={false}
        blockScrollOnMount={true}
        preserveScrollBarGap={true}
        trapFocus={true}
        returnFocusOnClose={true}
        size="xl"
      >
        <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(10px)" />
        <ModalContent borderRadius="xl" overflow="hidden">
          <Box bgGradient="linear(to-r, #f37022, #ff8c42)" p={4} color="white">
            <HStack>
              <Icon as={MdAssignment} boxSize={6} />
              <ModalHeader p={0} fontSize="xl" fontWeight="bold">Assign Driver & Vehicle</ModalHeader>
            </HStack>
          </Box>
          <ModalCloseButton color="white" />
          
          <ModalBody p={6}>
            <VStack spacing={5} w="full">
              {/* Delivery Partner Selection */}
              <FormControl>
                <FormLabel fontWeight="bold" color="gray.700" display="flex" alignItems="center" gap={2}>
                  <Icon as={FiTruck} color="orange.500" />
                  Select Delivery Partner
                </FormLabel>
                <Select
                  value={udpateAsingData.dplist || ""}
                  onChange={(e) =>
                    setUdpateAsingData({
                      ...udpateAsingData,
                      dplist: e.target.value,
                      dplist_error: "",
                    })
                  }
                  placeholder="Select Delivery Partner"
                  size="lg"
                  borderColor="gray.300"
                  _hover={{ borderColor: "orange.400" }}
                  _focus={{
                    borderColor: 'orange.400',
                    boxShadow: '0 0 0 1px rgba(243, 112, 34, 0.6)',
                  }}
                >
                  {dp_list?.map((item) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.name}
                    </option>
                  ))}
                </Select>
                {udpateAsingData.dplist_error && (
                  <Text color="red.500" fontSize="sm" mt={1}>
                    {udpateAsingData.dplist_error}
                  </Text>
                )}
              </FormControl>

              {/* Vehicle Selection */}
              <FormControl>
                <FormLabel fontWeight="bold" color="gray.700" display="flex" alignItems="center" gap={2}>
                  <Icon as={FiTruck} color="orange.500" />
                  Select Vehicle
                </FormLabel>
                <Select
                  value={udpateAsingData.vehicle || ""}
                  onChange={(e) =>
                    setUdpateAsingData({
                      ...udpateAsingData,
                      vehicle: e.target.value,
                      vehicle_error: "",
                    })
                  }
                  placeholder="Select Vehicle"
                  size="lg"
                  disabled={!udpateAsingData.dplist}
                  borderColor="gray.300"
                  _hover={{ borderColor: "orange.400" }}
                  _focus={{
                    borderColor: 'orange.400',
                    boxShadow: '0 0 0 1px rgba(243, 112, 34, 0.6)',
                  }}
                >
                  {vehicle_loading ? (
                    <option disabled>Loading vehicles...</option>
                  ) : (
                    dp_vehicle_list?.map((item) => (
                      <option key={item.vehicle_id} value={item.vehicle_id}>
                        {item.vehicleno}
                      </option>
                    ))
                  )}
                </Select>
                {vehicle_loading && (
                  <HStack mt={2} color="orange.500">
                    <Spinner size="sm" />
                    <Text fontSize="sm">Loading vehicles...</Text>
                  </HStack>
                )}
                {udpateAsingData.vehicle_error && (
                  <Text color="red.500" fontSize="sm" mt={1}>
                    {udpateAsingData.vehicle_error}
                  </Text>
                )}
              </FormControl>

              {/* Driver Selection */}
              <FormControl>
                <FormLabel fontWeight="bold" color="gray.700" display="flex" alignItems="center" gap={2}>
                  <Icon as={FiUser} color="orange.500" />
                  Select Driver
                </FormLabel>
                <Select
                  value={udpateAsingData.driver || ""}
                  onChange={(e) =>
                    setUdpateAsingData({
                      ...udpateAsingData,
                      driver: e.target.value,
                      driver_error: "",
                    })
                  }
                  placeholder="Select Driver"
                  size="lg"
                  disabled={!udpateAsingData.vehicle}
                  borderColor="gray.300"
                  _hover={{ borderColor: "orange.400" }}
                  _focus={{
                    borderColor: 'orange.400',
                    boxShadow: '0 0 0 1px rgba(243, 112, 34, 0.6)',
                  }}
                >
                  {driver_loading ? (
                    <option disabled>Loading drivers...</option>
                  ) : (
                    vehicle_driver_list?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))
                  )}
                </Select>
                {driver_loading && (
                  <HStack mt={2} color="orange.500">
                    <Spinner size="sm" />
                    <Text fontSize="sm">Loading drivers...</Text>
                  </HStack>
                )}
                {udpateAsingData.driver_error && (
                  <Text color="red.500" fontSize="sm" mt={1}>
                    {udpateAsingData.driver_error}
                  </Text>
                )}
              </FormControl>

              {/* Customer Information */}
              {udpateAsingData.driver && returnData && (
                <Box
                  mt={4}
                  p={5}
                  w="full"
                  bg="blue.50"
                  borderRadius="lg"
                  border="2px solid"
                  borderColor="blue.200"
                >
                  <HStack mb={4}>
                    <Icon as={FiUser} color="blue.600" boxSize={5} />
                    <Text fontSize="lg" fontWeight="bold" color="blue.700">
                      Customer Information
                    </Text>
                  </HStack>
                  <VStack spacing={3} align="stretch">
                    <CustomerDetailList
                      title="Customer Name"
                      value={returnData.customer_name}
                    />
                    <CustomerDetailList
                      title="Phone Number"
                      value={returnData.mobile}
                    />
                    <CustomerDetailList
                      title="Email"
                      value={returnData.email}
                    />
                    <CustomerDetailList
                      title="Shipping Address"
                      value={returnData.shipping_address}
                    />
                    <Box p={3} bg="white" borderRadius="md" mt={2}>
                      <Text fontWeight="bold" mb={2} color="gray.700">Order Items:</Text>
                      {details?.map((el, i) => (
                        <CustomerDetailList
                          key={i}
                          title={el.product_name}
                          value={`Qty: ${el.qty || 0}`}
                          fontWeight="normal"
                          fontSize="14px"
                        />
                      ))}
                    </Box>
                  </VStack>
                </Box>
              )}
            </VStack>
          </ModalBody>

          <ModalFooter bg="gray.50" borderTop="1px solid" borderColor="gray.200" gap={3} justifyContent="center">
            <Button
              colorScheme="green"
              size="lg"
              px={8}
              onClick={handleAssignOrder}
              isLoading={isAssigning}
              loadingText="Assigning..."
              disabled={isAssigning || isAlreadyAssigned}
              leftIcon={<MdAssignment />}
              _focus={{
                boxShadow: '0 0 0 2px rgba(72, 187, 120, 0.6)',
              }}
            >
              {isAssigning ? "Assigning..." : "Assign Order"}
            </Button>
            <Button
              colorScheme="red"
              size="lg"
              px={8}
              onClick={handleModalClose}
              disabled={isAssigning}
              _focus={{
                boxShadow: '0 0 0 2px rgba(245, 101, 101, 0.6)',
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default DefectDetail;